import './IntroPanel.css'
import React, { PureComponent, Fragment } from 'react'
import { getFileUrl, getThemeColor } from 'utils/utils'
import NETImage from 'components/net-image'

/**
 * 课程简介
 */
export default class IntroPanel extends PureComponent {
    get themeColor() {
        const {
            theme
        } = this.props

        return getThemeColor(theme).default
    }

    get tips() {
        const {
            theme
        } = this.props

        return getFileUrl(theme, '/tips.png')
    }

    render() {
        const {
            theme,
            intros,
            presenters,
        } = this.props
        
        const {
            host,
            tags,
            cover,
            title,
            episode,
            duration,
            language,
            synopsis,
            presenters: pids,
        } = intros

        return (
            <Fragment>
                <NETImage
                    className='ip-cover'
                    prefix={theme}
                    src={cover}
                    useAutoHeight
                    usePreview
                />
                <div className='ip-brief'>
                    <div className='ip-brief-episode'>{episode}</div>
                    <div className='ip-brief-title'>{title}</div>
                    <div className='ip-brief-tag'>
                        <span>主讲人：&ensp; </span>
                        <div>
                            {
                                pids.map((item, i) => {
                                    return `${presenters[item].name}${i + 1 === pids.length ? '' : '、'}`
                                })
                            }
                        </div>
                    </div>
                    {
                        host && (
                            <div className='ip-brief-tag'>
                                <span>主持人：&ensp; </span>
                                <div>{host}</div>
                            </div>
                        )
                    }
                    <div className='ip-brief-tag'>
                        <span>时&emsp;长：&ensp; </span>
                        <div>{duration}</div>
                    </div>
                    <div className='ip-brief-tag'>
                        <span>语&emsp;言：&ensp; </span>
                        <div>{language}</div>
                    </div>
                    <div className='ip-brief-tag'>
                        <span>标&emsp;签：&ensp; </span>
                        <div>{tags}</div>
                    </div>
                </div>
                <div className='ip-intros'>
                    <div className='ip-intros-title'>本集梗概：</div>
                    {
                        synopsis.map((item, i, { length }) => <p className='ip-intros-p' key={i} style={{ marginBottom: i + 1 === length ? 20 : 0 }}>{item}</p>)
                    }
                    {
                        theme === 'fgxyp' && (
                            <NETImage
                                useAutoHeight
                                prefix={theme}
                                src='/tip.svg'
                                className='ip-intros-tips'
                            />
                        )
                    }
                    <div className='ip-intros-title'>主讲人：</div>
                    {
                        pids.map(idx => {
                            const item = presenters[idx]
                            return (
                                <PresenterItem
                                    item={item}
                                    theme={theme}
                                    key={item.id}
                                />
                            )
                        })
                    }
                </div>
            </Fragment>
        )
    }
}

class PresenterItem extends PureComponent {
    get avatar() {
        const { theme, item } = this.props
        return getFileUrl(theme, item.avatar)
    }

    render() {
        const { item } = this.props

        return (
            <div key={item.id} className='ip-intros-presenter-holder'>
                <div className='presenter-title'>
                    <img alt='' className='presenter-avatar' src={this.avatar} style={{ borderColor: item.color }} />
                    <span className='presenter-name'>{item.name}</span>
                </div>
                <p className='presenter-area'>{item.intros}</p>
            </div>
        )
    }
}